import { FC } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import EmailCodeBlock from "./EmailCodeBlock";
import type { CodeGate } from "./emailCode";

/**
 * Where the email code (1NOW-10770) is asked on the way to paying. On the booking steps it is a card at the top of
 * the Pay step, in place of the card form until the code is right: the payment does not exist before it (the
 * booking is only made once the renter is who they say), so there is nothing to type a card into yet.
 */
export const EmailCodeCard: FC<{ gate: CodeGate }> = ({ gate }) => (
  <div data-testid="email-code-card">
    <div className="rounded-3xl border border-secondary-100 bg-card-color p-4 sm:p-6">
      <EmailCodeBlock {...gate} />
    </div>
    <p className="mt-3 text-sm text-text-color/70">Payment opens once your code is confirmed.</p>
  </div>
);

/**
 * The same box over the car page, for the page that has no steps (long-term trips): its "Pay & Book" goes straight
 * on to the checkout page, so the code is asked first, here.
 */
export const EmailCodeDialog: FC<{ gate: CodeGate; onClose: () => void }> = ({ gate, onClose }) => (
  <Dialog as="div" open onClose={onClose} aria-label="Check your email" className="relative z-50">
    <div className="fixed inset-0 bg-black/55" aria-hidden="true" />
    <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <DialogPanel className="relative w-full max-w-md rounded-3xl border border-secondary-100 bg-bg-color p-5 sm:p-6">
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute right-4 top-4 text-text-color opacity-70 hover:opacity-100"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
          <EmailCodeBlock {...gate} />
        </DialogPanel>
      </div>
    </div>
  </Dialog>
);
